import React, { useEffect, useState } from "react";
import { cookieHtml } from "../../api/modules/loothoot.class";
import FullAppLoader from "../../components/Loader/FullAppLoader";
import { useDispatch, useSelector } from "react-redux";
import { toggleLoader } from "../../redux/slices/loaderSlice";
import { Container } from "react-bootstrap";

const Cookie = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.loader?.isLoading);
  const [value, setValue] = useState();
  useEffect(() => {
    try {
      dispatch(toggleLoader({ isLoading: true }));
      cookieHtml()
        .then((response) => {
          setValue(response?.data?.data);

          dispatch(toggleLoader({ isLoading: false }));
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log("Failed", e);
    }
  }, [dispatch]);
  return isLoading ? (
    <FullAppLoader />
  ) : (
    <Container className="px-5 py-5">
      <h1 className="text-center p-3">Cookie Policy</h1>
      {value
        ? value?.map((item, index) => (
            <div dangerouslySetInnerHTML={{ __html: item?.description }} />
          ))
        : null}
    </Container>
  );
};

export default Cookie;
